import styled from 'styled-components';
import { Button } from '../../components';
import { colors, fonts } from '../../styles/theme';

export const WrapperStyled = styled.div`
  display: grid;
  grid-template-columns: 23% calc(100% - 23%);
  height: 100vh;
`;

export const LeftStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.color1};
`;

export const RightStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const RightContentStyled = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 4rem;
  flex-flow: column nowrap;

  h1 {
    color: ${colors.color1};
    margin-bottom: 1rem;
    line-height: 1.2;
    ${fonts.gotham.H26M};
    text-align: center;
  }

  span {
    margin-bottom: 3rem;
    text-align: center;
    ${fonts.lato.H16}
  }

  img{
    width: 75%;
    margin-bottom: 1rem;
  }

  a {
    color: ${colors.color1};
    &:hover {
      color: ${colors.color2};
    }
  }
`;

export const ButtonContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ButtonSignUpStyled = styled(Button)`
  width: 30%;
  padding: 1rem;
  margin-right: 2rem;
`;

export const ButtonStyled = styled(Button)`
  width: 20%;
  padding: 1rem;
  margin-right: 2rem;
`;
